export default {
    game_id: "vikings",
    gameName : "Vikings",

    stageWidth: 1280,
    stageHeight: 720,

    scripts: [
        'framework/src/vendor/jquery.min.js',
        'framework/src/vendor/tween.js',
        'framework/src/vendor/ph.js',
    ],

    infoPages: {
        separated: true
    },

    game: {
        webfonts: [
            {className: "font_TeXGyrePagella"},
            "UbuntuMono-Regular",
            "Audiowide-Regular"
        ],
        audio: {
            tracks: [
                {
    name: 'Jackpot_sound',
    classVol: 'volume.normalWin',
    loop: false,
},
{
    name: 'JokerBonus_alert',
    classVol: 'volume.normalWin',
    loop: false,
},
            ]
        },
        freespins: {
            autostart: false
        },
    },
    system: {
        audio: {
            tracks: []
        }
    }
}
